import type { MapProgressData } from '../MapProgress';

// Абстракция хранилища прогресса. Реализации: TelegramCloudStorage (Mini App),
// localStorage (обычный браузер), in-memory (fallback). Игровая логика не знает
// какой провайдер используется — выбирается factory'ем на старте.
export interface SaveProvider {
  /** Сохранить прогресс. Throw при ошибке. */
  save(data: MapProgressData): Promise<void>;

  /** Загрузить прогресс. null если нет сохранения (новый игрок). */
  load(): Promise<MapProgressData | null>;

  /** Удалить сохранение (для дебага/сброса). */
  clear(): Promise<void>;

  /** Идентификатор провайдера (для логов/дебага). */
  readonly name: string;
}

export const SAVE_STORAGE_KEY = 'forest_guardian_progress';
